export const getSpeakers = (streams: any) => {
  if (!streams) {
    return [];
  }
  const speakersList: any[] = [];
  const speakersIds = new Set();
  streams.forEach((stream: any) => {
    if ('episode' in stream === false) {
      return;
    }
    stream.episode.forEach((episode: any) => {
      if ('speakers' in episode === false) {
        return;
      }
      episode.speakers.forEach((speaker: any) => {
        if (!speakersIds.has(speaker.id)) {
          speakersIds.add(speaker.id);
          speakersList.push(speaker);
        }
      });
    });
  });
  return speakersList;
};
